import styled from 'styled-components';

const EmoticonContainer = styled.div`
	flex-wrap: wrap;
	justify-content: space-between;
	gap: 16px;
	flex-direction: row;
	display: flex;
`;

export default EmoticonContainer;
